import { render, staticRenderFns } from "./AsfPageFormBuilder.vue?vue&type=template&id=fa1f4798&scoped=true"
import script from "./AsfPageFormBuilder.vue?vue&type=script&lang=js"
export * from "./AsfPageFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1f4798",
  null
  
)

export default component.exports